import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useEmitAPIEvent } from '@elfsight/widget-js-api';
import { createReadableClass } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { API_INIT_EVENT } from '../constants';
import { FormPopup } from './form-popup';
import { Layout } from './layouts';
import { Deactivation, FreeLink, Toggles, WidgetTitle } from './main';

export function Widget() {
  const settings = useSettings();
  const ref = useRef(null);
  const emitAPIEvent = useEmitAPIEvent();

  useEffect(() => {
    // setTimeout - костыль, убрать после релиза https://elfsight.atlassian.net/browse/WIDGETS-2999
    setTimeout(() =>
      emitAPIEvent(API_INIT_EVENT, [{ settings, widgetContainer: ref.current }])
    );
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Deactivation childrenRef={ref}>
      <Container>
        <WidgetTitle />
        <Toggles />

        <Layout />

        <FreeLink />

        <FormPopup />
      </Container>
    </Deactivation>
  );
}

const Container = styled.div.attrs({
  className: createReadableClass({ component: 'widget', element: 'container' })
})`
  margin: 0 auto;
  position: relative;
`;
